/**
 * This is temporarily needed due to Safari 17.4 still being very recent.
 * See https://caniuse.com/mdn-javascript_builtins_promise_withresolvers
 * to decide if needed to be removed.
 */
Promise.withResolvers ??= function <T>() {
    let resolve: PromiseWithResolvers<T>['resolve'];
    let reject: PromiseWithResolvers<T>['reject'];
    const promise = new Promise<T>((res, rej) => {
        resolve = res;
        reject = rej;
    });
    return { promise, resolve: resolve!, reject: reject! };
};
